import DesignInsights from './DesignInsights';

export default DesignInsights;
